import(/* webpackMode: "eager" */ "/codebuild/output/src2094359739/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
